import React from "react";
import AvatarCircle from "./AvatarCircle";
import { useNavigate } from "react-router-dom";


const UserList = ({ users, size, textColor }) => {
    const navigate = useNavigate()
    return (
        <div >
            {users.map((user) => (
                <div key={user.id}
                    className="flex items-center space-x-4 p-4 cursor-pointer hover:bg-gray-200 hover:bg-opacity-50 rounded-lg"
                    onClick={() => {  if(user.username) navigate(`/user/${user.username}`)}}
                >
                    {/* RandomColorBox on the left */}
                    <AvatarCircle letters={user.name} size={size ? size : "size-16"} />

                    {/* Name and subtitle on the right */}
                    <div>
                        <p className={`${textColor ? textColor : "text-gray-100"} text-lg font-semibold`}>{user.name}</p>
                        <p className={`"text-sm" ${textColor ? textColor : "text-gray-100"}`}>{user.caption}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UserList;